if (import.meta.env.DEV || (import.meta.env.VITE_APP_ENV !== 'production' && import.meta.env.VITE_APP_ENV !== 'pre')) {
	import('vconsole').then(({ default: VConsole }) => {
		new VConsole();
	});
}

import 'virtual:uno.css';
import 'virtual:svg-icons-register';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/image-preview/style';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { vBtn } from '@h5-monorepo/shared/directives/button';
import { vLazyImage, vLazyBackground } from '@h5-monorepo/shared/directives/lazy';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import '@vant/touch-emulator';
import { errorMonitor } from '@h5-monorepo/shared/utils/errorMonitor.js';
import { installEmbedTheme } from '@h5-monorepo/shared/theme/embed';
import '@h5-monorepo/shared/assets/fonts/ThemeFonts.css';

// 被社区内嵌时接收其主题；独立打开保持 main 默认主题
const disposeEmbedTheme = installEmbedTheme({
	vant: 'full',
	trustedOrigins: import.meta.env.VITE_APP_COMMUNITY_ORIGINS,
	dev: import.meta.env.DEV
});
if (import.meta.hot) import.meta.hot.dispose(disposeEmbedTheme);

const app = createApp(App);

// 配置 Pinia
const pinia = createPinia();
pinia.use(
	createPersistedState({
		storage: localStorage
	})
);

app.use(router).use(vBtn).directive('lazy-image', vLazyImage).directive('lazy-background', vLazyBackground).use(pinia);

// 将router实例注入到全局属性中，供shared包使用
app.config.globalProperties.$router = router;
// 同时通过provide方式注入router，确保inject可以正常工作
app.provide('$router', router);

app.mount('#app');

if (import.meta.env.VITE_APP_ENV === 'production') {
	// 初始化错误监控
	errorMonitor.initJavaScriptErrorMonitor();
	// 设置Vue错误处理器
	app.config.errorHandler = errorMonitor.createVueErrorHandler();
}
